const initialState = {
  cancelOrderResult: {},
};

// 取消订单参数
export default function queryCancelOrder(state = initialState, action) {
  switch (action.type) {
  case 'SHOW_ORDER_BOOKING':
    return { ...state, cancelOrderResult: action.payload };
  default:
    return state;
  }
}